import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import C from '../../shared/constants/general';

export type SessionStatus =
  | 'studio'
  | 'live'
  | 'finished'
  | 'paused'
  | 'paused_no_event'
  | 'waiting';

export const useSessionStatus = (room: any): SessionStatus => {
  const { video_state, video_access } = room;
  const location = useLocation();
  const studio = queryString.parse(location.search).studio;

  const videoState = useMemo<SessionStatus>(() => {
    if (studio) {
      return 'studio';
    }
    if (room) {
      if (video_state === C.PROGRAM_ROOM.VIDEO_STATE.FILE) {
        return 'finished';
      }

      if (
        video_state === C.PROGRAM_ROOM.VIDEO_STATE.STREAMING_NO_EVENT_SELECTED
      ) {
        return 'paused_no_event';
      }

      if (video_state === C.PROGRAM_ROOM.VIDEO_STATE.DISABLED) {
        return 'paused';
      }

      if (
        (room.video_state === C.PROGRAM_ROOM.VIDEO_STATE.STREAMING ||
          room.video_state === C.PROGRAM_ROOM.VIDEO_STATE.RECORDING) &&
        (room.video_access === C.PROGRAM_ROOM.ACCESS.OPEN_FOR_VISITORS ||
          room.video_access === C.PROGRAM_ROOM.ACCESS.OPEN_FOR_PUBLIC)
      ) {
        return 'live';
      }
    }

    return 'waiting';
  }, [video_state, video_access]);

  return videoState;
};
